import { GimliCustomerData } from '@vfde-sails/avc-core';
import { AppAction, ProviderType } from './enum';
import { AppState, BackendError, PublicFactName } from './interface';
import { JarvisHomebox } from '../../interface';

export const initStore = (state: Partial<AppState>) => ({
    type: AppAction.INIT_STORE,
    state,
} as const);

export const setLoading = (isLoading: boolean) => ({
    type: AppAction.SET_LOADING,
    isLoading,
} as const);

export const setError = (error?: BackendError) => ({
    type: AppAction.SET_ERROR,
    error,
} as const);

export const setDisableBooking = (disableBooking: boolean) => ({
    type: AppAction.SET_DISABLE_BOOKING,
    disableBooking,
} as const);

export const setPublicFactName = (publicFactName: PublicFactName) => ({
    type: AppAction.SET_PUBLIC_FACT_NAME,
    publicFactName,
} as const);

export const setCustomerType = (customerType: string) => ({
    type: AppAction.SET_CUSTOMER_TYPE,
    customerType,
} as const);

export const setSelectedRouterId = (selectedId: string) => ({
    type: AppAction.SET_SELECTED_ROUTER,
    selectedId,
} as const);
export const setAvailableRouterIds = (routerIds: string[]) => ({
    type: AppAction.SET_AVAILABLE_ROUTER_IDS,
    routerIds,
} as const);

export const setRouters = (routers: JarvisHomebox[]) => ({
    type: AppAction.SET_ROUTERS,
    routers,
} as const);

export const setProviderType = (providerType: ProviderType) => ({
    type: AppAction.SET_PROVIDER_TYPE,
    providerType,
} as const);

export const setCustomer = (customer: GimliCustomerData) => ({
    type: AppAction.SET_CUSTOMER,
    customer,
} as const);

export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setDisableBooking>
    | ReturnType<typeof setPublicFactName>
    | ReturnType<typeof setCustomerType>
    | ReturnType<typeof setSelectedRouterId>
    | ReturnType<typeof setAvailableRouterIds>
    | ReturnType<typeof setRouters>
    | ReturnType<typeof setProviderType>
    | ReturnType<typeof setCustomer>;
